export enum PortfolioType {
    benchmark = 'benchmark',
    standard = 'standard',
}
